<div>
  <div class="page-title">
    <h1>
      Sale Orders
      <button
        class="btn btn-primary"
        (click)="getReportData()"
        *ngIf="selection.selected.length > 0"
      >
        Print Packing Slips
      </button>
    </h1>
  </div>
  <div class="page-body">
    <div class="row">
      <div class="col-md-3">
        <div class="form-group">
          <label for="">Search</label>
          <input
            type="text"
            class="form-control"
            [(ngModel)]="tableModel.search"
          />
        </div>
      </div>
      <div class="col-md-3" style="align-content: center">
        <button class="btn btn-primary mr-3" (click)="getList()">Search</button>
        <button class="btn btn-primary mr-3" (click)="reset()">Reset</button>
      </div>
    </div>
    <div class="card mt-3">
      <table
        mat-table
        [dataSource]="dataSource"
        class="mat-elevation-z8"
        *ngIf="dataSource.data.length > 0"
      >
        <!-- Checkbox Column -->
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef>
            <mat-checkbox
              (change)="$event ? masterToggle() : null"
              [checked]="selection.hasValue() && isAllSelected()"
              [indeterminate]="selection.hasValue() && !isAllSelected()"
            >
            </mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let row">
            <mat-checkbox
              (click)="$event.stopPropagation()"
              (change)="$event ? selection.toggle(row) : null"
              [checked]="selection.isSelected(row)"
            >
            </mat-checkbox>
          </td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="salesOrderNumber">
          <th mat-header-cell *matHeaderCellDef>Sales Order No.</th>
          <td mat-cell *matCellDef="let element">
            {{ element.salesOrderNumber }}
          </td>
        </ng-container>

        <ng-container matColumnDef="salesOrderName">
          <th mat-header-cell *matHeaderCellDef>Sales Order Name</th>
          <td mat-cell *matCellDef="let element">
            {{ element.salesOrderName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef>Date</th>
          <td mat-cell *matCellDef="let element">
            {{ element.orderCreationDateTime | date }}
          </td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef>Email</th>
          <td mat-cell *matCellDef="let element">{{ element.email }}</td>
        </ng-container>

        <ng-container matColumnDef="address">
          <th mat-header-cell *matHeaderCellDef style="width: 25%">Address</th>
          <td mat-cell *matCellDef="let element" style="width: 25%">
            {{ element.deliveryAddressStreet }},
            {{ element.deliveryAddressCity }},
            {{ element.deliveryAddressCountryRegionId }}
          </td>
        </ng-container>

        <ng-container matColumnDef="notes">
          <th mat-header-cell *matHeaderCellDef>Notes</th>
          <td mat-cell *matCellDef="let element">{{ element.notes }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
      <h4 class="text-center" *ngIf="!(dataSource.data.length > 0)">
        No Records Found
      </h4>
      <mat-paginator
        #paginator
        [length]="total"
        [pageSizeOptions]="[10, 50, 100]"
        [pageSize]="tableModel.limit"
        showFirstLastButtons
        (page)="onPaginate($event)"
      >
      </mat-paginator>
    </div>
  </div>
</div>
